import { Box, Button, Flex, Spacer } from '@rockr/rock-ui'
import React from 'react'
import styled from 'styled-components'

const DivFooter = styled.div`
position: absolute;
width: 100%;
left: 0;
background: #fff;
padding: 0px 10px;
border-top: 1px solid #E9EEF5;
margin-top: 20px;
`

type Props = {
  goToPreviousStep: any,
  canGoBack: any,
  isLastStep: boolean,
  submitting: boolean
}

export const Footer: React.FC<Props> = ({
  goToPreviousStep,
  canGoBack,
  isLastStep,
  submitting
}) => (
  <DivFooter>
    <Flex>
      <Box p="4">
        <Button
          colorScheme="blue"
          variant="outline"
          type="button"
          onClick={goToPreviousStep}
          disabled={!canGoBack}
        >
          Previous
        </Button>
      </Box>
      <Spacer />
      <Box p="4">
        <Button colorScheme="blue" type="submit" isLoading={submitting}>
          {isLastStep ? 'Submit' : 'Next'}
        </Button>
      </Box>
    </Flex>
  </DivFooter>
)
